import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';


class FilterConversationItem extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onClick(this.props.value);
  }

  render() {
    let item = (
      <NavLink to={this.props.path} className="dropdown-menu__item">
        {this.props.label}
      </NavLink>
    );

    const itemProps = {
      onClick: this.onClick,
    };

    if (this.props.type === 'BUTTON') {
      item = (
        <div
          className={classnames('dropdown-menu__item', this.props.className)}
          {...itemProps}
        >
        <div className="dropdown-menu__item_element">
            <div className={classnames("dropdown-menu__item_element_data",{'long-name':this.props.value==='MISSED_CALL_VM'})}>
                {/* <div className="name">{this.props.value}</div> */}
                <input type="checkbox" value={this.props.value} name={this.props.value} checked={this.props.filter.includes(this.props.value)} />
                <label className="filter-name" for={this.props.value}>{this.props.label}</label>
            </div>
        </div>
        </div>
      );
    }

    return item;
  }
}

FilterConversationItem.defaultProps = {
  label: '',
  path: '',
  type: 'LINK',
  onClick: () => {},
  value: '',
};

FilterConversationItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  path: PropTypes.string,
  type: PropTypes.oneOf(['LINK', 'BUTTON']),
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default FilterConversationItem;
